var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 13.125V15M6.875 9.375H6.88125V9.38125H6.875V9.375ZM6.875 11.25H6.88125V11.2563H6.875V11.25ZM6.875 13.125H6.88125V13.1313H6.875V13.125ZM6.875 15H6.88125V15.0063H6.875V15ZM8.9563 9.375H8.96255V9.38125H8.9563V9.375ZM8.9563 11.25H8.96255V11.2563H8.9563V11.25ZM8.9563 13.125H8.96255V13.1313H8.9563V13.125ZM8.9563 15H8.96255V15.0063H8.9563V15ZM11.0437 9.375H11.05V9.38125H11.0437V9.375ZM11.0437 11.25H11.05V11.2563H11.0437V11.25ZM11.0437 13.125H11.05V13.1313H11.0437V13.125ZM11.0437 15H11.05V15.0063H11.0437V15ZM13.125 9.375H13.1313V9.38125H13.125V9.375ZM13.125 11.25H13.1313V11.2563H13.125V11.25ZM6.875 5H13.125V6.875H6.875V5ZM10 1.875C8.42333 1.875 6.86797 1.96622 5.3389 2.14367C4.42173 2.25011 3.75 3.04083 3.75 3.96416V16.25C3.75 17.2855 4.58947 18.125 5.625 18.125H14.375C15.4105 18.125 16.25 17.2855 16.25 16.25V3.96416C16.25 3.04083 15.5783 2.25011 14.6611 2.14367C13.132 1.96622 11.5767 1.875 10 1.875Z",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAccounting);
export default __webpack_public_path__ + "static/media/svg_accounting.7f08290a7643935afb30c06c7ad1b503.svg";
export { ForwardRef as ReactComponent };